<a
  [routerLink]="href"
  class="text-[#FE6313] [&:hover>mat-icon]:rotate-[90deg] uppercase"
  >{{ text }}
  <mat-icon class="rotate-[45deg] translate-y-[0.3rem] transition-all"
    >arrow_upward</mat-icon
  ></a
>
